import $ from 'jquery';

import { transformCalcInputToJson, formatCurrency, trackFilterEventViaField } from './helpers.js';
import { SELECTORS } from './constants';

function displayInputInTable($form, $table) {
  const inputData = $form.find(SELECTORS.CALCULATOR_INPUT).serializeArray();
  if (inputData.length) {
    const { value } = inputData[0];
    const formattedValue = formatCurrency(value);
    const $tableContainer = $table.closest(SELECTORS.COMPARISON_CALCULATOR);
    $tableContainer.find(SELECTORS.CALCULATOR_INPUT_DISPLAY).html(formattedValue);
    $table.find(SELECTORS.CALCULATOR_INPUT_DISPLAY).html(formattedValue);
  }
}

function calculateTableColumn($form, $table) {
  const calcValues = $form.find(SELECTORS.CALCULATOR_FIELDS).serializeArray();
  const input = transformCalcInputToJson(calcValues, $form);
  if (window.finder && window.finder.calculators) {
    window.finder.calculators.fetchResults($table, input);
  }
}

function updateTable($form, $table) {
  displayInputInTable($form, $table);
  calculateTableColumn($form, $table);
}

function recalculateTableColumn(e, $form, $table) {
  updateTable($form, $table);
}

function calculateTableColumnOnLoad($form, $table) {
  if ($form.find(SELECTORS.CALCULATOR_FIELDS).length) {
    if (document.readyState !== 'loading') {
      updateTable($form, $table);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        updateTable($form, $table);
      });
    }
  }
}

function initializeCustomCalculatorFields($form, $table) {
  $table.on('recalculateTableColumn', recalculateTableColumn);

  let typingFinished = null;
  $form.find(SELECTORS.CALCULATOR_FIELDS).on('keyup', (event) => {
    clearTimeout(typingFinished);
    typingFinished = setTimeout(function calculateInput() {
      trackFilterEventViaField($(event.target));
      updateTable($form, $table);
    }, 500);
  });

  $form.find(SELECTORS.CALCULATOR_FIELDS).on('keydown', () => {
    clearTimeout(typingFinished);
  });

  $table.on('calculator-table-complete', function attachTooltipEvent() {
    $table.find('.calculator-data .table-popover').popover({
      placement: 'bottom',
      trigger: 'hover',
    });
  });

  calculateTableColumnOnLoad($form, $table);
}

export default initializeCustomCalculatorFields;
